export const mockAuditLogs = [
  {
    id: 1,
    user_name: "Oscar Dev",
    action: "UPDATE",
    module: "Case",
    record_id: "583",
    case_id: "CS000012",
    ip_address: "192.168.10.139",
    created_at: "2024-06-19T18:53:59.000Z",
    changes: [
      {
        field_name: "Identification Number",
        old_value: "",
        new_value: "",
        is_changed: false
      },
      {
        field_name: "Identification Description",
        old_value: "",
        new_value: "",
        is_changed: false
      },
      {
        field_name: "State",
        old_value: "fdsfds",
        new_value: "fdsfds",
        is_changed: false
      },
      {
        field_name: "City",
        old_value: "fdsfd",
        new_value: "fdsfduyh",
        is_changed: true
      },
      {
        field_name: "External POC",
        old_value: "",
        new_value: "",
        is_changed: false
      },
      {
        field_name: "Managed By",
        old_value: "",
        new_value: "",
        is_changed: false
      },
      {
        field_name: "Clients",
        old_value: "tes tes t test est",
        new_value: "tes tes t test est",
        is_changed: false
      },
      {
        field_name: "Status",
        old_value: "Active",
        new_value: "Active",
        is_changed: false
      },
      {
        field_name: "1 Relation Type",
        old_value: "",
        new_value: "",
        is_changed: false
      },
      {
        field_name: "1 Associative Client",
        old_value: "",
        new_value: "",
        is_changed: false
      }
    ]
  },
  {
    id: 2,
    user_name: "Jane Smith",
    user_email: "jane.smith@example.com",
    action: "UPDATE",
    module: "COUPON",
    description: "Updated coupon 'SUMMER2024' status to active",
    ip_address: "192.168.1.101",
    user_agent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)",
    created_at: "2024-03-15T11:15:00.000Z"
  },
  {
    id: 3,
    user_name: "Admin User",
    user_email: "admin@example.com",
    action: "DELETE",
    module: "PLAN",
    description: "Deleted plan 'Basic Monthly'",
    ip_address: "192.168.1.102",
    user_agent: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1)",
    created_at: "2024-03-15T12:00:00.000Z"
  },
  {
    id: 4,
    user_name: "Support Team",
    user_email: "support@example.com",
    action: "VIEW",
    module: "USER",
    description: "Viewed user profile details",
    ip_address: "192.168.1.103",
    user_agent: "Mozilla/5.0 (Linux; Android 11)",
    created_at: "2024-03-15T12:30:00.000Z"
  }
]; 